export const cashToFloat = (value) => {
  // replace non-numeric characters with empty string
  const cleanedValue = value.replace(/[^0-9.]/g, '');
  return parseFloat(cleanedValue);
}